let baseUrl = 'https://sarfe.bpc.ir/';

// let baseUrl = 'http://92.61.182.123/';
// let baseUrl = 'http://192.1.101.80/';
// let baseUrl = 'http://192.1.100.21/';
// let baseUrl = 'http://192.1.101.37/html/';

const apiUrls = {
     mainPageLink: "http://localhost:3000/",
    // mainPageLink: "https://sarfemarket.ir/",
     ordersPageLink: "http://localhost:3000/orders",
    //ordersPageLink: "https://sarfemarket.ir/orders",
    baseUrlWithDefault: baseUrl + "index.php?route=app/",
    getProducts: 'productV04/getProductsV01',
    getProductsCount: 'productV04/getProductsCountV01',
    getUnusedRewardsTypes: 'reward/getUnusedRewardsTypes',
    getInviteFriend: 'loginV02/getInviteFriend',
    getUnusedRewards: 'reward/getUnusedRewards',
    getProductsDefaultInfo: 'productV04/getProductsDefaultInfoV01',
    getParentCategory: 'productV04/getParentCategory',
    getParentCategoryWithChilds: 'productV04/getParentCategoriesWithChilds',
    getCategoriesBySupllier: 'productV04/getCategoriesBySupllier',
    addToBasket: 'cartV04/addCart',
    removeFromBasket: 'cartV04/removeCart',
    deleteFromBasket: 'cartV04/deleteCart',
    getAllManufacturer: 'productV04/getAllManufacturer',
    getHomeData: 'productV04/getHomeData',
    login: 'loginV02/register',
    loginWithVerifyCode: 'loginV02/CheckSmsCode',
    registerAgentByLink: 'loginV02/registerAgentByLink',
    editLoginNumber: 'loginV02/editLoginNumber',
    getCartAndRewardsSetting: 'cartV04/getCartAndRewardsSetting',
    getCart: 'cartV04/getCartV02',
    getProvinces: 'accountV02/getCountry',
    getCities: 'accountV02/getZone',
    addAddress: 'accountV02/addAddress',
    rateOrder: 'cartV04/orderRate',
    getOrdersStatus: 'cartV04/getOrdersStatus',
    editAddress: 'accountV02/editAddress',
    getAddresses: 'accountV02/getAddresses',
    deleteAddress: 'accountV02/deleteAddress',
    setDefaultAddress: 'accountV02/setDefaultAddress',
    getCartSetting: 'cartV04/getCartSettingV03',
    getDeliveryTimes: 'cartV04/getDeliveryTimes',
    addOrder: 'cartV04/addOrderV03',
    getPaymentRequestTransaction: 'cartV04/getPaymentRequestTransaction',
    getPaymentInfo: 'cartV04/getPaymentInfo',
    sendOrderToInternetPayment: 'cartV04/sendOrderToInternetPayment',
    managePaymentResult: 'cartV04/managePaymentResult',
    getPaymentResult: 'cartV04/getPaymentResult',
    getOrders: 'cartV04/getOrdersV01',
    getOrdersCount: 'cartV04/getOrdersCount',
    cancelOrder: 'cartV04/cancelOrderV01',
    completeOrder: 'cartV04/completeOrder',
    editOrder: 'cartV04/editOrderV01',
    deleteAllCart: 'cartV04/deleteAllCart',
    getProductDetail: 'productV04/getProductDatail',
    getUser: 'accountV02/getUserData',
    addTicket: 'supportV02/addTicketV01',
    addTicketComment: 'supportV02/addTicketV01',
    uploadImage: 'supportV02/uploadImage',
    deleteImage: 'supportV02/deleteImage',
    getAllTicket: 'supportV02/getAllTicketV02',
    getTicketsCount:'supportV02/getCountTicket',
    getTicketSubject: 'supportV02/ticket_Subject',
    getTicketDetail:'supportV02/getTicketDetail',
    editProfile: 'accountV02/editProfile',
    getAboutUs: 'supportV02/getAboutUs',
    getOrderDetail: 'cartV04/getOrderV01',
    getSearchAvailableItems: 'productV04/getSearchAvailableItems',
    getUnauthorizedProduct: 'productV04/getUnauthorizedProduct',
    addAllToCart: 'cartV04/addAllToCart',
    getCartWithChangesSet: 'cartV04/getCartWithChangeSetsV02',
    notifyAvailableProduct: 'productV04/notifyAvailableProducts',
    getNeighbourhoods: 'accountV02/getNeighbourhood',
    getHomeDynamicData: 'productV04/getHomeDynamicData',
    getPeykLocation: 'peykV03/getPeykLocation',
    getNotifications: 'notification/getNotificationsByCustomer',
    getNotificationsCount: 'notification/getNotificationsCountByCustomer',
    getUnreadNotificationsCount: 'notification/getUnreadNotificationsCountByCustomer',
    readNotification: 'notification/readCustomerNotifications',
    deleteNotification: 'notification/deleteCustomerNotifications',
    getProductsForDynamicList: 'productV04/getProductsForDynamicList',
    insertCustomerBehaviour: 'customerBehaviour/insertCustomerBehaviour',
    neshanSearch: 'https://api.neshan.org/v1/search?term=',
    neshanSearchEndText: '&lat=0&lng=0',
    sendWalletToInternetPayment: 'wallet/sendWalletToInternetPayment',
    getWalletPaymentInfo: 'wallet/getWalletPaymentInfo',
    chargeWallet: 'wallet/chargeWallet',
    getWalletPaymentResult: 'wallet/getWalletPaymentResult',
    getCustomerWallet: 'wallet/getWallet',
    getWalletTransactions: 'wallet/getWalletTransactions',
    getWalletTransactionsCount: 'wallet/getWalletTransactionsCount',
    getArticle: 'article/getArticle',
    getCommentSuggestType:'productComment/getSuggestType',
    getCommentConfigFile: 'productComment/getConfigFile',
    addProductComment:"productComment/addComment",
    getProductComments:"productComment/getComments",
    getProductCommentsCount:"productComment/getCountProductComment",
};

export default apiUrls